import { ref } from "vue";
import engine from "../core/index";

// ─────────────────────────────────────────────────────────────────────────
// Module « Configuration »
// But actuel : saisir un token / une clé puis cliquer sur Valider (envoi backend).
// Pensé pour évoluer : ajoute ici d'autres champs / actions plus tard.
// ─────────────────────────────────────────────────────────────────────────
export default function () {
    // Valeur saisie dans le champ token / clé
    const token = ref("");
    // Token actuellement utilisé (affiché dans sa propre carte, pas dans le champ)
    const currentToken = ref("");
    // État de chargement pendant l'appel backend (désactive le champ + spinner bouton)
    const isLoading = ref(false);
    // Retour visuel utilisateur (snackbar)
    const snackbar = ref({ show: false, text: "", color: "" });

    const showMessage = function (text, color) {
        snackbar.value = { show: true, text: text, color: color };
    };

    // Extrait la valeur du token depuis la réponse backend, quelle que soit sa forme
    // (chaîne directe, { token }, { data }, ou format FileMaker data.data[0].fieldData).
    const extractToken = function (data) {
        if (!data) return "";
        if (typeof data.token === "string") return data.token;
        if (typeof data.data === "string") return data.data;
        if (data.data && typeof data.data.token === "string") return data.data.token;
        try {
            let fd = data.data && data.data.data && data.data.data[0] && data.data.data[0].fieldData;
            if (fd) return fd.token || fd.TOKEN || fd.Value || "";
        } catch (e) { /* ignore */ }
        return "";
    };

    // Charge le token de configuration en cours et le pré-remplit dans le champ.
    const loadCurrentToken = function () {
        isLoading.value = true;
        engine.get_configuration_token(function (data) {
            isLoading.value = false;
            console.log("get_configuration_token", data);
            if (data && data.code === 0) {
                currentToken.value = extractToken(data);
            }
        });
    };

    // Envoi du token au backend.
    // ⚠️ engine.set_configuration_token est un PLACEHOLDER (voir core/index.js) :
    // remplace le nom de la fonction / de l'endpoint quand tu auras le vrai.
    const validate = function () {
        let value = (token.value || "").trim();
        if (value.length === 0) {
            showMessage("Merci de saisir un token / une clé.", "error");
            return;
        }
        isLoading.value = true;
        engine.set_configuration_token(value, function (data) {
            isLoading.value = false;
            if (data && data.code === 0) {
                // Met à jour l'affichage du token actuel + vide le champ de saisie
                currentToken.value = value;
                token.value = "";
                showMessage("Token validé avec succès.", "success");
            } else {
                showMessage("Échec de la validation du token.", "error");
            }
        });
    };

    // Au démarrage : récupère le token actuellement utilisé.
    loadCurrentToken();

    return {
        token,
        currentToken,
        isLoading,
        snackbar,
        validate,
    };
}
